import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import useRoles from '@/hooks/useRoles';
import { useIsChatEnabled } from '../hooks/useIsChatEnabled';
import { isTechSupportUser, parseTechSupportUsers } from './techSupportAccess';




// Является ли текущий пользователь участником отдела техподдержки
const useIsTechSupport = () => {
  const profile = useSelector(selectProfile)
  const techSupportUsersSetting = useSelector((store: any) => store.settings.techSupportUsers);
  const isTechSupportEnabled = useSelector((store: any) => store.settings.isTechSupportEnabled);
  const isTechnicalSupportFloatingIconDisabled = useSelector(
    (store: any) => store.settings.disableTechnicalSupportFloatingIconForAll === '1'
  );


  const disabledTechnicalSupportForChildren = useSelector((store: any) => store.settings.disabledTechnicalSupportForChildren === '1');
  const disabledTechnicalSupportForParent = useSelector((store: any) => store.settings.disabledTechnicalSupportForParent === '1');
  const disabledTechnicalSupportForEmployee = useSelector((store: any) => store.settings.disabledTechnicalSupportForEmployee === '1');

  const {isChildren, isEmployee, isParent} = useRoles();
  const {isChatEnabled} = useIsChatEnabled();
 
  const techSupportUsers = parseTechSupportUsers(techSupportUsersSetting);
  const isTechSupport = isTechSupportUser(
    profile?.id,
    techSupportUsers,
    isTechSupportEnabled,
  );
  const technicalSupportIsEnabled = isTechSupportEnabled === '1' && (
    isTechSupport
    || (isChildren && !disabledTechnicalSupportForChildren)
    || (isParent && !disabledTechnicalSupportForParent)
    || (isEmployee && !disabledTechnicalSupportForEmployee)
  );
  const chatIsDisabledButTechnicalSupportIsEnabled = !isChatEnabled && technicalSupportIsEnabled;

  const settings = {
    dirtyTechSupportUsers: techSupportUsers,
    isTechSupportEnabled
  }

  return {
    isTechSupport,
    settings,
    chatIsDisabledButTechnicalSupportIsEnabled,
    technicalSupportIsEnabled,
    isTechnicalSupportFloatingIconDisabled,
  }
}

export default useIsTechSupport
